import { useGetBackDocumentaleFascicoliIdDocumentiId } from '@framework/api-client';

const DOCUMENTAL_DOCUMENT_AUTH_TOKEN_HEADER = 'Authorization-Documenti';

interface IDocumentalDocumentQueryOptions {
  documentalToken: string;
  enabled?: boolean | undefined;
}

/**
 * Ottieni i dati di un documento, ovvero i suoi allegati
 */
export function useDocumentalDocumentQuery(
  dossierId: string | null | undefined,
  documentId: string | null | undefined,
  options: IDocumentalDocumentQueryOptions,
) {
  const attachmentsResult = useGetBackDocumentaleFascicoliIdDocumentiId(
    dossierId ?? '',
    documentId ?? '',
    {
      query: {
        enabled: dossierId != null && documentId != null && options.enabled,
      },
      request: {
        headers: {
          [DOCUMENTAL_DOCUMENT_AUTH_TOKEN_HEADER]: `${options.documentalToken}`,
        },
      },
    },
  );

  return {
    isLoading: attachmentsResult.isLoading,
    isFetching: attachmentsResult.isFetching,
    error: attachmentsResult.error,
    attachments: attachmentsResult.data?.data,
  };
}
